import { Ability, AbilityBuilder, defineAbility } from '@casl/ability';
import { Rules } from '@contexts/ability/Rules';
import { Roles } from '@utils/constants';
import AuthService from '@services/AuthService';

export const setRules = (can, cannot, userRoles) => {
  //metodo donde se define las acciones por rol
  //tener en cuenta que cuando haya multiples rols por usuarios dejar el rol mas grande ultimo
  if (!userRoles) return false;

  if (userRoles.includes(Roles.TESTER)) {
    can(Rules.Actions.TESTER);
  }
};

const ability = defineAbility((can, cannot) => {
  //metodo principal donde se settean y definen las reglas. las reglas (rules) son todos los can y cannot definidos
  const userRoles = AuthService.getCurrentUserRoles();
  setRules(can, cannot, userRoles);
});

export default ability;

export const updateAbility = (userRoles) => {
  //metodo para actualizar las rules al realizarse un login o logoff
  const { can, cannot, rules } = new AbilityBuilder(Ability);
  setRules(can, cannot, userRoles);
  ability.update(rules);
};
